import post from '../postService'
import URL from '../../Constants/apiUrls'

export default async function changeAssetFormIOStatusFormultiple(reqData) {
  try {
    const res = await post(`${URL.changeAssetFormIOStatusFormultiple}`, reqData)
    return res.data
  } catch (error) {
    return error
  }
}
